(function () {
  var root = document.getElementById('cpd'); if (!root) return;
  var D = JSON.parse(document.getElementById('cpd-data').textContent);
  var V = D.variants, S = D.s;
  /* i18n: strings come from sections/coffee-product.liquid (| t | json); __price__ / __n__ sentinels */
  function tr(s, vars) { s = s == null ? '' : String(s); Object.keys(vars || {}).forEach(function (k) { s = s.split('__' + k + '__').join(vars[k]); }); return s; }
  var cur = V.filter(function (v) { return v.id === D.current; })[0] || V[0];
  var plan = null, nums = [];
  root.querySelectorAll('.cpd__fbtn').forEach(function (b) {
    var m = (b.dataset.raw || '').match(/(\d+)\s*(week|wk)/i);
    if (m) { var n = parseInt(m[1], 10); b.textContent = tr(n === 1 ? S.wksOne : S.wksOther, { n: m[1] }); nums.push(m[1]); }
  });
  document.querySelectorAll('[data-freqs]').forEach(function (el) { el.textContent = nums.join('/'); });
  var fb = root.querySelector('.cpd__fbtn[aria-pressed="true"]'); if (fb) plan = fb.getAttribute('data-plan');

  /* money: the theme's one formatter (layout/theme.liquid, CHiATO_formatMoney), cents in.
     Round 10: the fallback used shop.money_format, which is pinned to the BASE currency, so it
     would have printed € on a DKK price. It now names the active currency by ISO code. */
  function money(c) {
    if (typeof window.CHiATO_formatMoney === 'function') return window.CHiATO_formatMoney(c);
    return (c / 100).toFixed(2) + ' ' + ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '');
  }
  function unit(v) {
    var t = v.options.join(' '), m = t.match(/(\d+(?:[.,]\d+)?)\s*(kg|g)\b/i);
    if (m) { var g = parseFloat(m[1].replace(',', '.')) * (m[2].toLowerCase() === 'kg' ? 1000 : 1); return tr(S.perKg, { price: money(Math.round(v.price * 1000 / g)) }); }
    var c = t.match(/(\d+)\s*\+\s*(\d+)\s*pcs/i) ? null : t.match(/(\d+)\s*pcs/i);
    if (c) return tr(S.perCup, { price: money(Math.round(v.price / parseInt(c[1], 10))) });
    return '';
  }
  function find(opts) { return V.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; }

  function render() {
    var subPrice = plan && cur.plans[plan] != null ? cur.plans[plan] : null;
    root.querySelectorAll('[data-once-price]').forEach(function (el) { el.textContent = money(cur.price); });
    root.querySelectorAll('[data-sub-price]').forEach(function (el) { el.textContent = subPrice != null ? money(subPrice) : money(cur.price); });
    root.querySelectorAll('[data-variant-title]').forEach(function (el) { el.textContent = V.length > 1 ? cur.title : ''; });
    root.querySelectorAll('.cpd__pill').forEach(function (b) {
      var i = +b.dataset.opt, val = b.dataset.val, opts = cur.options.slice(); opts[i] = val;
      var v = find(opts), on = cur.options[i] === val;
      if (!v) v = V.filter(function (x) { return x.options[i] === val && x.available; })[0];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.dataset.off = (!v || !v.available) ? 'true' : 'false';
      var u = b.querySelector('[data-unit]'); if (u) u.textContent = v ? unit(v) : '';
    });
    root.querySelectorAll('[data-add]').forEach(function (b) {
      b.disabled = !cur.available || (b.dataset.add === 'sub' && subPrice == null);
    });
    if (!cur.available) root.querySelectorAll('[data-add="once"]').forEach(function (b) { b.firstChild.nodeValue = S.soldOut + ' · '; });
  }

  root.querySelectorAll('.cpd__pill').forEach(function (b) {
    b.addEventListener('click', function () {
      var i = +b.dataset.opt, opts = cur.options.slice(); opts[i] = b.dataset.val;
      var v = find(opts);
      if (!v) { v = V.filter(function (x) { return x.options[i] === b.dataset.val && x.available; })[0] || V.filter(function (x) { return x.options[i] === b.dataset.val; })[0]; }
      if (!v) return;
      cur = v;
      if (v.image) { var img = document.getElementById('cpd-main-img'); if (img) { img.src = v.image; img.removeAttribute('srcset'); } }
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      render();
    });
  });
  root.querySelectorAll('.cpd__fbtn').forEach(function (b) {
    b.addEventListener('click', function () {
      plan = b.dataset.plan;
      root.querySelectorAll('.cpd__fbtn').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      render();
    });
  });
  root.querySelectorAll('.cpd__thumb').forEach(function (b) {
    b.addEventListener('click', function () {
      var img = document.getElementById('cpd-main-img'); if (!img) return;
      img.src = b.dataset.src; img.removeAttribute('srcset'); img.alt = b.dataset.alt;
      root.querySelectorAll('.cpd__thumb').forEach(function (x) { x.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
    });
  });

  function add(btn, payload) {
    if (btn.disabled || btn.dataset.loading === 'true') return;
    btn.dataset.loading = 'true';
    var html = btn.innerHTML; btn.textContent = S.adding;
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d && d.description); return d; }); })
      .then(function () { btn.textContent = S.added; document.dispatchEvent(new CustomEvent('cart:open')); document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(function (e) { console.error('Cart error:', e); btn.textContent = S.unavailable; })
      .finally(function () { setTimeout(function () { btn.innerHTML = html; btn.dataset.loading = 'false'; render(); }, 1600); });
  }
  root.querySelectorAll('[data-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      var p = { id: cur.id, quantity: 1 };
      if (b.dataset.add === 'sub' && plan) p.selling_plan = parseInt(plan, 10);
      add(b, p);
    });
  });
  document.querySelectorAll('[data-add-variant]').forEach(function (b) {
    b.addEventListener('click', function () { add(b, { id: parseInt(b.dataset.addVariant, 10), quantity: 1 }); });
  });

  var sticky = document.getElementById('cpd-sticky'), buy = root.querySelector('.cpd__buy [data-add="once"]');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var past = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      sticky.querySelectorAll('button').forEach(function (x) { x.tabIndex = past ? 0 : -1; });
    }).observe(buy);
  }
  render();
})();
